module.exports = __webpack_public_path__ + "static/media/f_l_08.3254675a.png";